import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import store from '../store';
import { CurrencyProvider } from '../components/currency';
import GeoIPProvider from '../components/geoip/GeoIPProvider';
import LandingPage from '../components/homepage/LandingPage';

const homepage = document.getElementById('home-page');
if (homepage) {
    createRoot(homepage).render(
        <Provider store={store}>
            <CurrencyProvider>
                <GeoIPProvider>
                    <LandingPage />
                </GeoIPProvider>
            </CurrencyProvider>
        </Provider>
    );
}
